import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

const type = "client";

// Define a service using a base URL and expected endpoints
export const clientApi = createApi({
  reducerPath: 'clientApi',
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: 0,
  keepUnusedDataFor: 0,
  tagTypes: [type],
  endpoints: (builder) => ({
    getClient: builder.query<any, { clientId: string }>({      
      query: (arg) => {
        const { clientId } = arg;
        return `client/${clientId}`
      },
      providesTags: (returnValue, args) => [{ type: type , id: 'LIST' }, ...(returnValue?.data || []).map((role: any) => ({ type: type, id: role.id }))]
      //[type]
    }),      
    getClients: builder.query<any, void>({
      query: () => {              
        return `client` },
      providesTags: (returnValue, args) => { return [{ type: type , id: 'LIST' }, ...(returnValue?.clients || []).map((client: any) => ({ type: type, id: client.id }))]}
    }),        
    add: builder.mutation<any, any>({
      query: (formData: any) => {        
        return {
        url: `client`,
        method: 'POST',
        body: formData,
      }},
      invalidatesTags: [type],
    }),  
    update: builder.mutation<any, any>({
      query: (formData: any) => {       
        const { clientId } = formData;
        return {
        url: `client/${clientId}`,
        method: 'PUT',
        body: formData,
      }},
      invalidatesTags: [type],
    }),
    delete: builder.mutation<any, any>({
      query: (formData: any) => {
        const { clientId } = formData;
        return {
        url: `client/${clientId}`,
        method: 'DELETE'
      }},
      invalidatesTags: [{ type: type, id: 'LIST' }]
    })    
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetClientQuery, 
               useGetClientsQuery,               
               useAddMutation, 
               useUpdateMutation, 
               useDeleteMutation               
             } = clientApi;